import type { NextApiResponse } from 'next'

import { type CookieSerializeOptions, serialize } from 'cookie'
import { PROD } from 'server/config'

import { DEVELOPER_DASHBOARD_DOMAIN } from '@infura/packages.common/constants'

export enum CookieNames {
  SESSION = '_s_',
  VERIFIED = '_v_',
  MFA = '_m_',
  BYPASS = 'bypass',
  SELECTED_API_KEY = 'selected_api_key'
}

const TWO_WEEKS_IN_SECONDS = 1209600
const ONE_DAY_IN_SECONDS = 86400

export const cookieOptions: CookieSerializeOptions = {
  domain: PROD ? '.metamask.io' : DEVELOPER_DASHBOARD_DOMAIN,
  httpOnly: true,
  maxAge: PROD ? ONE_DAY_IN_SECONDS : TWO_WEEKS_IN_SECONDS,

  path: '/',

  sameSite: PROD || DEVELOPER_DASHBOARD_DOMAIN == 'localhost' ? 'lax' : 'none',
  // this will send the cookie on navigation to site, handy for ssr
  secure: DEVELOPER_DASHBOARD_DOMAIN !== 'localhost' // 14 days in seconds
}

export function mergeCookie(res: NextApiResponse, cookie: string) {
  const current = res.getHeader('set-cookie')
  res.setHeader(
    'set-cookie',
    !current ? [cookie] : [...(Array.isArray(current) ? current.concat(cookie) : [current as string, cookie])]
  )
}

export function clearAllCookies(res: NextApiResponse) {
  res.setHeader(
    'set-cookie',
    Object.values(CookieNames).map(name => {
      // Selected API Key cookie is not httpOnly, so we need to clear it differently
      if (name === CookieNames.SELECTED_API_KEY) {
        return serialize(name, '', {
          expires: new Date(0),
          httpOnly: false,
          maxAge: 0,
          path: '/',

          sameSite: 'lax',
          secure: true
        })
      }

      return serialize(name, '', {
        ...cookieOptions,
        expires: new Date(0),
        maxAge: 0
      })
    })
  )
}
